import Column from '@components/column'
import CardHeading from '@commons/headings/card'
import Typography from '@components/typography'
import PatientSearch from './search'
import Image from '@components/image'
import { useSelector } from 'react-redux'
import Fields from '@components/fields'
import { Constant } from '@utils'
import { StyleRow } from './style'
const PatientProfileForm = ({ setFieldValue, values, error }) => {
  const { items: patients } = useSelector((state: any) => state.searchPatients)
  const handleClickPatient = (event: any) => {
    const id = (event.target as HTMLElement)
      .closest('[data-cross-id]')
      ?.getAttribute('data-cross-id')
    if (!!id) {
      const patient = patients?.find((patient) => patient?.id == id)
      setFieldValue('createdBy', id)
      setFieldValue('patient', patient)
    }
  }

  return (
    <Column rowGap={20}>
      <Column
        bg="white"
        styleColumn="border-radius:12px;padding:15px 20px"
        rowGap={20}
      >
        <CardHeading title="Search Patient" tc={'primary'} />
        <PatientSearch
          selectedItem={values?.createdBy}
          handleClickPatient={handleClickPatient}
        />
        {!!error && <Typography content={error} size={12} tc="danger" />}
      </Column>
      <Column bg="white" styleColumn="border-radius:12px;padding:15px 20px;">
        <Column alignItems="center" rowGap={20}>
          <Image
            fallbackType="user"
            src={`${process.env.BUCKET_URL}/${values?.patient?.avatar}`}
            width={80}
            height={80}
            styleImage={'border-radius:50%;'}
          />
          <Fields.Input
            name="patient.name"
            placeholder="Full Name"
            label="Full Name"
            disabled
          />
          <Fields.PhoneInput
            name="patient.phoneNo"
            placeholder="Mobile Number"
            label="Mobile Number"
            disabled
          />
          <Fields.Input
            name="patient.email"
            placeholder="Email"
            label="Email"
            disabled
          />
          <Fields.Input
            name="patient.infos.address"
            placeholder="Address"
            label="Address"
            disabled
          />
        </Column>
      </Column>
      <Column
        bg="white"
        styleColumn="border-radius:12px;padding:15px 20px"
        rowGap={20}
      >
        <CardHeading title="Profile Details" tc={'primary'} />
        <StyleRow>
          <Fields.ChooseButton
            name="patient.infos.gender"
            items={Constant.genders}
            titleAsKey="name"
            valueAsKey="name"
            multiple={false}
            label="Gender"
            disabled
          />
          <Fields.Input
            type="number"
            name="patient.infos.age"
            label="Age"
            placeholder="Age"
          />
        </StyleRow>
        <Fields.ChooseButton
          name="patient.infos.bloodGroup"
          items={Constant.bloodGroups}
          titleAsKey="name"
          valueAsKey="name"
          multiple={false}
          label="Blood Group"
          disabled
        />
        <Fields.ChooseButton
          name="patient.symptoms"
          label="Health Problems"
          styleButton="
          height:auto;
          border:0px;
        "
          items={
            !!values?.patient?.symptoms
              ? values?.patient?.symptoms?.map((symptom) => {
                  return {
                    id: symptom?.id,
                    name: symptom?.name,
                    render: () => {
                      return (
                        <Column rowGap={10} styleColumn="padding:5px 0px;">
                          <Image
                            src={`${process.env.BUCKET_URL}/${symptom?.infos?.image}`}
                            height={50}
                            width={50}
                            styleImage="border-radius:50%;"
                          />
                          <Typography content={symptom?.name} size={14} />
                        </Column>
                      )
                    },
                  }
                })
              : []
          }
          titleAsKey="name"
          valueAsKey="id"
        />
      </Column>
    </Column>
  )
}

export default PatientProfileForm
